import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import { RelationshipHttpRepository, RelationshipDummyRepository } from './infrastructure/repository';

// Application
import { SearchRelationshipsQuery } from './application/queries';

// Domain
import { RelationshipRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupRelationship(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_ALLIANZ_RELATIONSHIP_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<RelationshipRepository>(TYPES.CATALOG_ALLIANZ_RELATIONSHIP_REPOSITORY)
    .to(
      withDummies
        ? RelationshipDummyRepository
        : RelationshipHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchRelationshipsQuery>(TYPES.SEARCH_CATALOG_ALLIANZ_RELATIONSHIP_QUERY)
    .to(SearchRelationshipsQuery)
    .inSingletonScope();
}
